export type RackLayerRangeRow = {
  height: string;
  range: string;
};

export type ParsedRackLayerRanges =
  | { layerHeights: number[]; ok: true }
  | { error: string; ok: false };

export function createRackLayerRangeRows(layerHeights: readonly number[]) {
  const rows: RackLayerRangeRow[] = [];
  let start = 0;
  while (start < layerHeights.length) {
    const height = layerHeights[start];
    let end = start;
    while (end + 1 < layerHeights.length && layerHeights[end + 1] === height) {
      end += 1;
    }
    rows.push({
      height: String(Math.round((height ?? 0) * 1000)),
      range: start === end ? String(start + 1) : `${start + 1}-${end + 1}`
    });
    start = end + 1;
  }
  return ensureTrailingRackLayerRangeRow(rows);
}

export function ensureTrailingRackLayerRangeRow(rows: readonly RackLayerRangeRow[]) {
  const nonEmptyRows = rows.filter(({ height, range }) => height.trim() || range.trim());
  return [...nonEmptyRows, { height: "", range: "" }];
}

export function parseRackLayerRangeRows(rows: readonly RackLayerRangeRow[]): ParsedRackLayerRanges {
  const layerHeights: number[] = [];
  let expectedStart = 1;

  for (const row of rows) {
    const rangeText = row.range.trim();
    const heightText = row.height.trim();
    if (!rangeText && !heightText) {
      continue;
    }
    if (!rangeText || !heightText) {
      return { error: "每一行都需要同时填写层数范围和净层高", ok: false };
    }

    const match = /^(\d+)(?:-(\d+))?$/.exec(rangeText);
    if (!match) {
      return { error: "层数请输入单个数字或连续范围，例如 3 或 3-5", ok: false };
    }
    const start = Number(match[1]);
    const end = Number(match[2] ?? match[1]);
    if (start < 1 || end < start) {
      return { error: "层数范围必须从 1 开始，并且结束层不能小于起始层", ok: false };
    }
    if (start !== expectedStart) {
      return { error: `层数必须连续，下一行应从第 ${expectedStart} 层开始`, ok: false };
    }

    const heightMillimeters = Number(heightText);
    if (!Number.isFinite(heightMillimeters) || heightMillimeters <= 0) {
      return { error: "净层高必须是大于 0 的毫米数值", ok: false };
    }
    for (let layer = start; layer <= end; layer += 1) {
      layerHeights.push(heightMillimeters / 1000);
    }
    expectedStart = end + 1;
  }

  if (layerHeights.length === 0) {
    return { error: "至少需要设置一层", ok: false };
  }
  return { layerHeights, ok: true };
}
